import createDecorator from './create-decorator';
import handleDrop from './modifiers/handle-drop';
import { DRAFTJS_BLOCK_KEY } from './constants';

export default function createBlockDndPlugin() {
    const store = {
        getEditorRef: undefined,
        getReadOnly: undefined,
        getEditorState: undefined,
        setEditorState: undefined,
    };
    return {
        initialize: ({ getEditorRef, getReadOnly, getEditorState, setEditorState }) => {
            store.getReadOnly = getReadOnly;
            store.getEditorRef = getEditorRef;
            store.getEditorState = getEditorState;
            store.setEditorState = setEditorState;
        },
        decorator: createDecorator({ store }),
        handleDrop, //handleDrop is reserved prop in draft js to be called if declared
        handleBeforeInput: (chars,editorState,timestamp) => {
            let res = false;

            //added to prevent additional drop event caused by react-dnd adding dataTransfer text data from decorator
            if (chars.includes(DRAFTJS_BLOCK_KEY)) {
                /*do nothing*/
                res = 'handled'; //reserved key to notice draft js that handleDrop is handled and no action needed
            }
            return res;
        }
    };
};